import { Fragment, useEffect, useState } from 'react';

import { Text } from '../../FormControls/Text';
import { Stack } from '../../FormControls/Stack';
import { Box } from '../../FormControls/Box';

import { useDispatch, useSelector } from 'react-redux'
import { ScreenControl } from '../ScreenControl';
import { getOneShotContract } from '../../../../main/slices/userSlice';

export const OneshotContract = ({ dimensions }) => {
    
    const dispatch = useDispatch();

    // RETRIEVE THE ONESHOT CONTRACT
    const [contractHTML, setContractHTML] = useState('');

    useEffect(() => {
        const retrieveContract = async () => {
            try {
                const { response } = await dispatch(getOneShotContract()).unwrap();
                setContractHTML(response);
            } catch (error) {
                console.error('Error al recuperar el contrato:', error);
                return false;
            }
        };

        retrieveContract();
    }, [dispatch]);

    return (
        <Fragment>
            <Stack
                flex={{
                    flexDirection: "column",
                    alignContent: "center",
                    justifyContent: "center",
                    alignItems: "center"
                }}
                sx={{ ...dimensions }}
            >

                <Text classes={["smallTitle", "center"]}> Lee y firma el contrato </Text>
                <Box classes={["card", "cardShadow", "marginTB1em"]} style={{ minHeight: "400px", backgrounColor: "grey", overflowY: "auto", maxHeight: "400px" }}>
                    {/*  COMPONENT */}
                    <div dangerouslySetInnerHTML={{ __html: contractHTML }} />
                </Box>

            </Stack>

            <ScreenControl disabled={false}></ScreenControl>
        </Fragment >
    );
}